import { Injectable } from '@angular/core';
import { ColumnPreferenceTab } from 'src/app/modules/setting/column-preference/column-preference.component';
import { ColumnList } from 'src/app/shared/models/column-preference';

@Injectable({
  providedIn: 'root'
})

export class KPIColumnService {
  columnConfigurations: Record<string, ColumnList[]> =
    {
      KPI: [
        { id: 'route_label', label: 'Route', enable: true, order: 1, width: '80px', sort: '' },
        { id: 'route_state', label: 'Status', enable: true, order: 2, width: '80px', sort: '' },
        { id: 'kpi.stops.total', label: 'Stops', enable: true, order: 3, width: '68px', sort: '' },
        { id: 'kpi.tasks.total', label: 'Tasks', enable: true, order: 4, width: '68px', sort: '' },
        { id: 'kpi.items.total', label: 'Items', enable: true, order: 5, width: '68px', sort: '' },
        { id: 'kpi.tasks.completedPercentage', label: 'Completed%', enable: true, order: 6, width: '114px', sort: '' },
        { id: 'loaded_planned', label: 'Loaded/ Planned', enable: true, order: 7, width: '125px', sort: '' },
        { id: 'kpi.items.moved_in_out', label: 'Moved in/out', enable: true, order: 8, width: '120px', sort: '' },
        { id: 'kpi.items.planned_at_loading', label: 'Planned After Load Start', enable: true, order: 9, width: '195px', sort: '' },
        { id: 'kpi.tasks.pickup', label: 'Pickup', enable: true, order: 10, width: '77px', sort: '' },
        { id: 'workshift_name', label: 'Workshift', enable: true, order: 11, width: '96px', sort: '' },
        { id: 'kpi.tasks.tasks_left', label: 'Tasks Left', enable: true, order: 12, width: '99px', sort: '' },
        { id: 'kpi.tasks.tasks_pr_hour', label: 'Tasks/h', enable: true, order: 13, width: '82px', sort: '' },
        { id: 'kpi.items.weight', label: 'Weight', enable: true, order: 14, width: '79px', sort: '' },
        { id: 'kpi.items.volume', label: 'Volume', enable: true, order: 15, width: '81px', sort: '' },
        { id: 'vehicle.reg_no', label: 'Vehicle', enable: true, order: 16, width: '81px', sort: '' },
        { id: 'kpi.tasks.task_workload_variance', label: '+/- Task', enable: true, order: 17, width: '85px', sort: '' },
        { id: 'container_information.container_count', label: 'Container Count', enable: true, order: 18, width: '138px', sort: 'container_information.container_count' }
      ],
      MainKPI: [
        { id: 'route_label', label: 'Route', enable: true, width: '', sort: 'route_label', order: 1 },
        { id: 'route_state', label: 'Status', enable: true, width: '', sort: 'route_state', order: 2 },
        { id: 'kpi.stops.total', label: 'Stops', enable: true, width: '', sort: 'kpi.stops.total', order: 3 },
        { id: 'kpi.tasks.total', label: 'Tasks', enable: true, width: '', sort: 'kpi.tasks.total', order: 4 },
        { id: 'kpi.items.total', label: 'Items', enable: true, width: '', sort: 'kpi.items.total', order: 5 },
        { id: 'kpi.tasks.tasks_pr_hour', label: 'Task/h', enable: true, width: '', sort: 'kpi.tasks.tasks_pr_hour', order: 6 },
        { id: 'kpi.tasks.tasks_left', label: 'Tasks Left', enable: true, width: '', sort: 'kpi.tasks.tasks_left', order: 7 },
        { id: 'kpi.items.weight', label: 'Weight', enable: true, width: '', sort: 'kpi.items.weight', order: 8 },
        { id: 'kpi.items.volume', label: 'Volume', enable: true, width: '', sort: 'kpi.items.volume', order: 9 },
        { id: 'kpi.items.planned_at_sorting', label: 'Planned for Route', enable: true, width: '', sort: 'kpi.items.planned_at_sorting', order: 10 },
        { id: 'kpi.items.moved_in_out', label: 'Moved in/out', enable: true, width: '', sort: '', order: 11 },
        { id: 'kpi.items.planned_at_loading', label: 'Planned After Load Start', enable: true, width: '', sort: 'kpi.items.planned_at_loading', order: 12 },
        { id: 'kpi_extended.items.loaded_before_onroute', label: 'Loaded on Departure', enable: true, width: '', sort: 'kpi_extended.items.loaded_before_onroute', order: 13 },
        { id: 'kpi_extended.items.delivered', label: 'Completed as Delivered', enable: true, width: '', sort: 'kpi_extended.items.delivered', order: 14 },
        { id: 'kpi_extended.items.failedattempt', label: 'Failed Attempt', enable: true, width: '', sort: 'kpi_extended.items.failedattempt', order: 15 },
        { id: 'kpi_extended.items.not_completed', label: 'Not Completed', enable: true, width: '', sort: 'kpi_extended.items.not_completed', order: 16 },
        { id: 'kpi_extended.items.notified', label: 'Completed as Notified', enable: true, width: '', sort: 'kpi_extended.items.notified', order: 17 },
        { id: 'kpi_extended.items.pickup_completed', label: 'Completed as Picked Up', enable: true, width: '', sort: 'kpi_extended.items.pickup_completed', order: 16 },
        { id: 'kpi_extended.items.pickup_failed', label: 'Completed as Failed Pick up', enable: true, width: '', sort: 'kpi_extended.items.pickup_failed', order: 17 },
        { id: 'kpi_extended.items.pickup_not_completed', label: 'Pick up not completed', enable: true, width: '', sort: 'kpi_extended.items.pickup_not_completed', order: 18 },
        { id: 'kpi.items.letter.planned', label: 'Letter', enable: true, width: '', sort: 'kpi.items.letter.planned', order: 19 },
        { id: 'kpi.items.parcel.planned', label: 'Parcel', enable: true, width: '', sort: 'kpi.items.parcel.planned', order: 20 },
        { id: 'kpi.items.pallet.planned', label: 'Pallet', enable: true, width: '', sort: 'kpi.items.pallet.planned', order: 21 },
        { id: 'container_information.container_count', label: 'Container Count', enable: true, order: 24, width: '', sort: 'container_information.container_count' }
      ]
    }

  /**
   * helper method to get column id
   * @param componentKey - column id
   * @returns retunds key as ID
   */
  getColumns(componentKey: string): ColumnList[] {
    return this.columnConfigurations[componentKey] || [];
  }

  /**
   * Get the list of enable columns for KPI
   */
  getVisibleColumns(
    componentKey: string,
    savedColumns?: ColumnList[] 
  ): ColumnList[] {
    const savedMap = new Map(savedColumns?.map(col => [col.id, col]));

    const merged = this.columnConfigurations[componentKey].map(defaultCol => {
      const saved = savedMap.get(defaultCol.id);
      return saved
        ? { ...defaultCol, ...saved, width: defaultCol.width } // use saved config where available
        : { ...defaultCol, enable: true, width: defaultCol.width }; // new column → enable by default
    });
 
    const defaultIds = new Set(this.columnConfigurations[componentKey].map(c => c.id));
    const extraSaved = savedColumns?.filter(c => !defaultIds.has(c.id));

    return [...merged, ...extraSaved??[]].sort((a, b) => a.order - b.order);
  }

  generateDefaultColumnList(columnPreferenceTab: ColumnPreferenceTab) {
    const tab = columnPreferenceTab === ColumnPreferenceTab.KPI ? 'KPI': 'MainKPI';
    return {
      name: "Default Columns",
      id: columnPreferenceTab === ColumnPreferenceTab.KPI ? 'DefaultColumnKPI' : 'DefaultColumnMainKPI',
      columnList: this.getVisibleColumns(tab),
      type: columnPreferenceTab,
      description: "",
      createdDate: "",
    };
  }
}
